import { Box, Button, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export interface IMobileActivityErrorScreenProps {
}

export function MobileActivityErrorScreen(props: IMobileActivityErrorScreenProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', height: 'calc(100vh - 48px)', padding: 2 }}>
            <Typography textAlign={'center'} sx={{ marginTop: 'auto', marginBottom: 'auto' }}>
                {t('AttendanceErrorText')}
            </Typography>
            <Button variant='contained' sx={{ width: '100%' }}
                onClick={() => {
                    navigate('../activities');
                }}>
                {t('Continue')}
            </Button>
        </Box>
    );
}
